export default "__VITE_ASSET__fba96553__"